import { getImagenURL } from '../../../Utiles/Formatos';
import { Invert } from './Utils/Invert';
export function Imagen({ data, size }: any) {
    return <Invert data={data} size={size}>
        <img src={getImagenURL(data.props.img)} width='100%' alt='fsr'/>
    </Invert>
}
